/* eslint-disable */
export default {
  logging: 'Iniciando sesión…',
  logCall: 'Registrar llamada',
  editLog: 'Editar registro',
  select: 'Seleccionar una grabación que coincida',
  OnHold: 'En espera',
  Ringing: 'Llamando',
  CallConnected: 'Llamada conectada',
  unknownUser: 'Usuario desconocido',
  unknownNumber: 'Anónimo',
  unavailable: 'No disponible',
  viewDetails: 'Ver detalles',
  addEntity: 'Crear nuevo',
  addLog: 'Registro',
  text: 'Mensaje',
  call: 'Llamar',
  addContact: 'Agregar contacto',
  missedCall: 'Perdida',
  inboundCall: 'Entrante',
  outboundCall: 'Saliente',
  from: 'Desde',
  to: 'Para',
  hangup: 'Colgar',
  accept: 'Responder',
  toVoicemail: 'Enviar al buzón de voz',
  anonymous: 'Anónimo',
  mergeToConference: 'Combinar con la llamada activa',
  hold: 'Retener',
  unhold: 'Salir de espera',
  transfer: 'Transferir',
  reject: 'Rechazar',
  switchCall: 'Cambiar llamada a esta aplicación',
  callSwitch: 'Cambiar llamada',
  comfirmContext:
    'Actualmente, está en una llamada activa con {displayName}. ¿Desear continuar con la llamada en este dispositivo?',
  comfirmCancelButton: 'Cancelar',
  comfirmOKButton: 'Cambiar',
  ignore: 'Ignorar',
  holdAndAnswer: 'En espera y atender',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"addContact"@#@ @source: @#@"Add Contact"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"accept"@#@ @source: @#@"Answer"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"unhold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"switchCall"@#@ @source: @#@"Switch Call to this app"@#@
// @key: @#@"callSwitch"@#@ @source: @#@"Call Switch"@#@
// @key: @#@"comfirmContext"@#@ @source: @#@"You're currently on an active call with {displayName}. Would you like to continue the call on this device?"@#@
// @key: @#@"comfirmCancelButton"@#@ @source: @#@"Cancel"@#@
// @key: @#@"comfirmOKButton"@#@ @source: @#@"Switch"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
